@if (collection$(); as collection) {
  <article class="overflow-hidden">
    <app-detail-header-gallery
      class="position-relative z-2"
      [image]="collection.image"
      [images]="collection.gallery"
      [subtitle]="collection.subtitle"
      [title]="collection.title"
      [intro]="collection.intro"
      [cookiePreferences]="cookiePreferences()"
    >
      <app-breadcrumbs class="mb-4 mb-md-5 d-block" [backButton]="true" [breadcrumbs]="breadcrumbs" above></app-breadcrumbs>
    </app-detail-header-gallery>
    <!--
    <header class="pt-topbar bg-accent">
      <div class="container section-inset-y text-max-width-sm mx-auto">
        <h1 class="h2">{{ collection.title }}</h1>
      </div>

      @if (collection.image) {
        <fstr-image [image]="collection.image" [fill]="true"></fstr-image>
      }
    </header>-->

    @if (collection.text) {
      <section class="container pb-3 pb-md-4 mt-3">
        <ngx-dynamic-hooks
          class="markdown-content d-block text-max-width-sm mx-auto"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="collection.text | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>
      </section>
    }
  </article>
}

<section class="section-inset-y">
  @if (otherCollections$(); as relatedCollections) {
    <div class="container">
      <h1 class="h3">{{ 'museum-collectie-detail-gerelateerd-titel' | fromDictionary }}</h1>

      <ul class="row">
        @for (collection of relatedCollections; track $index) {
          <li class="col-xsm-12 col-lg-6">
            <app-museum-collection-card
              [collection]="collection"
              [cookiePreferences]="cookiePreferences() || undefined"
            ></app-museum-collection-card>
          </li>
        }
      </ul>
    </div>
  }

  <div class="container text-center mt-5">
    <fstr-link cssClasses="button button-link button--primary button--xs" [button]="breadcrumbs[0]" [showText]="false">
      <fstr-icon anchor="line-icon-grid"></fstr-icon>
      <span>{{ 'alle-collecties-link-tekst' | fromDictionary }}</span>
    </fstr-link>
  </div>
  <!--<app-breadcrumbs class="container d-block mt-5 text-center" [backButton]="true" [breadcrumbs]="breadcrumbs" above></app-breadcrumbs>-->
</section>
